/**
 * A conta do turno na tela — a mesma do banco (coluna gerada `org.turno.horas`,
 * migração 0027), repetida aqui só para o formulário mostrar as horas enquanto
 * se digita. O que vale é o banco; este arquivo tem teste para não divergir.
 */

/** 0 é domingo, como `extract(dow)` no banco. */
export const DIAS_DA_SEMANA = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'] as const;

function minutos(hora: string): number | null {
  const m = /^(\d{2}):(\d{2})$/.exec(hora);
  if (!m) return null;
  return Number(m[1]) * 60 + Number(m[2]);
}

/** Horas de um turno. Fim antes do início passa da meia-noite. */
export function horasDoTurno(t: { readonly inicio: string; readonly fim: string; readonly intervaloMin: number }): number {
  const ini = minutos(t.inicio);
  const fim = minutos(t.fim);
  if (ini === null || fim === null) return 0;
  const duracao = fim - ini + (fim <= ini ? 1440 : 0);
  return Math.max(0, Math.round(((duracao - t.intervaloMin) / 60) * 100) / 100);
}

/** As horas programadas de cada dia da semana, somando os turnos daquele dia. */
export function horasPorDia(
  turnos: readonly { readonly diaSemana: number; readonly inicio: string; readonly fim: string; readonly intervaloMin: number }[],
): readonly number[] {
  const dias = [0, 0, 0, 0, 0, 0, 0];
  for (const t of turnos) {
    if (t.diaSemana >= 0 && t.diaSemana <= 6) dias[t.diaSemana] = (dias[t.diaSemana] ?? 0) + horasDoTurno(t);
  }
  return dias;
}

/**
 * O TURNO ACRESCENTADO repete o de cima no dia seguinte (31/10/2026): quem
 * monta a semana escreve o horário uma vez e vai acrescentando. Sem linha
 * nenhuma, o padrão de antes: Diurno, segunda, das 07:00 às 17:00.
 */
export function turnoAcrescentado(
  anterior: { readonly nome: string; readonly diaSemana: number; readonly inicio: string; readonly fim: string; readonly intervaloMin: number } | undefined,
): { nome: string; diaSemana: number; inicio: string; fim: string; intervaloMin: number } {
  if (anterior === undefined) return { nome: 'Diurno', diaSemana: 1, inicio: '07:00', fim: '17:00', intervaloMin: 60 };
  return { nome: anterior.nome, diaSemana: (anterior.diaSemana + 1) % 7, inicio: anterior.inicio, fim: anterior.fim, intervaloMin: anterior.intervaloMin };
}
